import { useState, useEffect } from "react";
import { getRecommendedSkus } from "../../services/sku";
import { RECOMMEDED_SKUS_CRUMBS } from "../../constants/crumbs";
import PortalBreadcrumb from "../UI/Breadcrumb/PortalBreadcrumb/PortalBreadcrumb";
import SkuCard from "../SkuCard/SkuCard";
import Loading from "../UI/Loading/Loading";
import EmptyContent from "../UI/EmptyContent/EmptyContent";
import classes from "./RecommendedSkus.module.css";

const RecommendedSkus = () => {
  const [skus, setSkus] = useState([]);
  //   const [skusTotalCount, setSkusTotalCount] = useState(0);
  //   const [pageNumber, setPageNumber] = useState(0);
  //   const [pageLimit] = useState(12);
  const [isSkusLoading, setIsSkusLoading] = useState(true);
  const [skusLoadingError, setSkusLoadingError] = useState("");

  //   const mainContentRef = useRef();

  //   const scrollToMainContentSection = () => {
  //     mainContentRef?.current.scrollIntoView({ behavior: "smooth" });
  //   };

  //   const currentPageChangedHandler = (pageNumber) => {
  //     setPageNumber(pageNumber);
  //     scrollToMainContentSection();
  //   };

  useEffect(
    () => {
      const fetchSkus = async () => {
        try {
          setIsSkusLoading(true);
          setSkusLoadingError("");
          const response = await getRecommendedSkus(/*pageNumber, pageLimit*/);
          const {
            data: { skuList },
          } = response;
          setSkus(skuList);
          //   setSkusTotalCount(Number(skusCount));
        } catch (err) {
          setSkusLoadingError("لا يوجد منتجات لعرضها !");
        } finally {
          setIsSkusLoading(false);
        }
      };

      fetchSkus();
    },
    [
      /*pageNumber, pageLimit*/
    ]
  );

  return (
    <div>
      <PortalBreadcrumb paths={RECOMMEDED_SKUS_CRUMBS} />

      <div className={classes["skus-grid"]}>
        {isSkusLoading ? (
          <Loading className={classes["skus-grid__loading"]} />
        ) : skusLoadingError || skus.length === 0 ? (
          <EmptyContent
            message="لا يوجد منتجات لعرضها !"
            className={classes["skus-grid__empty"]}
          />
        ) : (
          <>
            {skus.map((sku, index) => (
              <SkuCard
                key={index}
                id={sku.id}
                imageUrl={sku.imageUrl}
                brandName={sku.skuBrand}
                name={sku.commercialName}
                price={sku.suggestedSellingPrice}
                isIncludedInBundles={sku.isIncludedInBundle}
                availableQuantity={sku.quantity}
                isCartRuleApplied={sku.isCartRuleApplied}
              />
            ))}
            {/* <Pagination
              className={classes["skus-grid__pagination"]}
              currentPage={pageNumber}
              pageSize={pageLimit}
              total={skusTotalCount}
              onPageChange={currentPageChangedHandler}
            /> */}
          </>
        )}
      </div>
    </div>
  );
};

export default RecommendedSkus;
